import { createContext, useContext, useState } from "react";
import AIFeedbackFormModal from "./AIFeedbackFormModal";
import { useMultiLoading } from "../../../../helpers/Utils";

const feedbackFormModalContext = createContext();

export const useFeedbackFormModalContext = () => {
	return useContext(feedbackFormModalContext);
}

export const FeedbackFormModalContextProvider = ({ children }) => {
	const [feedbackType, setFeedbackType] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [targetMessageId, setTargetMessageId] = useState(null);
	const [isUpdate, setIsUpdate] = useState(false);
	const [newFeedback, setNewFeedback] = useState(null);
	const [deleteFeedback, setDeleteFeedback] = useState(null);
	
	const {
		isLoading,
		addLoading,
		finishLoading,
	} = useMultiLoading();

	const createFeedback = (type, messageId, isUpdate = false) => {
		setFeedbackType(type);
		setIsModalOpen(true);
		setTargetMessageId(messageId);
		setIsUpdate(isUpdate);
	}

	return (
		<feedbackFormModalContext.Provider value={{
			isUpdate,
			feedbackType,
			setFeedbackType,
			isModalOpen,
			setIsModalOpen,
			createFeedback,
			targetMessageId,
			setTargetMessageId,
			isLoading,
			addLoading,
			finishLoading,
			newFeedback,
			setNewFeedback,
			deleteFeedback,
			setDeleteFeedback,
		}}>
			{children}
		</feedbackFormModalContext.Provider>
	)
}

const AIFeedbackFormModalContainer = () => {
	const {
		targetMessageId,
		isModalOpen,
		setIsModalOpen,
		feedbackType,
		isUpdate,
		addLoading,
		finishLoading,
		setNewFeedback,
	} = useFeedbackFormModalContext();

	return (
		<AIFeedbackFormModal 
			isUpdate={isUpdate}
			show={isModalOpen}
			onHide={() => setIsModalOpen(false)}
			messageId={targetMessageId} 
			feedbackType={feedbackType}  
			onStart={() => addLoading(targetMessageId)}
			onSubmitSuccess={(feedbackData) => {
				setNewFeedback(feedbackData);
				finishLoading(targetMessageId);
			}}
			onFailure={() => finishLoading(targetMessageId, -1)}
			onFinish={() => finishLoading(targetMessageId, -1)}
		/>
	);
}

export default AIFeedbackFormModalContainer;